import React from 'react';
import styles from './Legal.module.css'; // Shared legal styling

const DataDeletion = () => {
  return (
    <div className={styles.legalPage}>
      <div className={styles.container}>
        <h1>Data & Account Deletion</h1>
        <p className={styles.lastUpdated}>Last Updated: March 2026</p>

        <section className={styles.content}>
          <h2>Your Data is Yours</h2>
          <p>LeanWeek-AI is built on a <strong>local-first architecture</strong>. This means we do not store your personal health data, biometrics, or fitness plans on our servers.</p>
          
          <h3>How to Delete Your Data</h3>
          <p>Since your data lives exclusively on your device, deleting your data is simple and under your total control:</p>
          
          <ol>
            <li><strong>Reset within the App:</strong> Go to Settings {'>'} Reset All Data. This will immediately wipe all local plans and biometric inputs.</li>
            <li><strong>Delete the App:</strong> Uninstalling LeanWeek-AI from your iPhone or Android device automatically removes all associated local storage data.</li>
          </ol>

          <h3>Account Deletion</h3>
          <p>Because LeanWeek-AI does not require an account to function, there is no "Account" to delete from our systems. We do not hold your email, name, or password in a central database.</p>
          
          <h3>Subscription Data</h3>
          <p>If you have a Premium subscription, billing data is handled by Apple (App Store) or Google (Play Store). To cancel or remove payment history, please visit your device's Subscription settings.</p>
        </section>
      </div>
    </div>
  );
};

export default DataDeletion;